import { cx } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { Button } from '../../../button';
import { Text } from '../../../text';
import { useTooltip } from '../../../tooltip';
import { useDateNavigatorContext } from './date-navigator-context';
import { styles } from './date-navigator.styles';
import { DateNavigatorButtonProps } from './date-navigator.types';
import { DefaultButtonContent } from './default-button-content';

export const DateNavigatorButton = ({ trackingIds, selectorWidth = 134, children }: DateNavigatorButtonProps) => {
  const { t } = useTranslation();
  const { value, datePickerDialogProps, showError, formattedDateObj, errorElement } = useDateNavigatorContext();

  const { Tooltip, triggerProps: tooltipTriggerProps, tooltipProps } = useTooltip({ hoverDelay: 1000 });
  const { triggerProps, open: popoverActive, toggle } = datePickerDialogProps;

  const isActive = popoverActive;

  return (
    <>
      <div css={{ minWidth: selectorWidth }}>
        <Button
          {...tooltipTriggerProps}
          {...triggerProps}
          className={cx(styles.calendarIcon, styles.dateSelectorContainerState(isActive, showError))}
          trackingId={trackingIds?.datePicker}
          variant={popoverActive ? 'tertiary' : 'secondary'}
          iconName='calendar'
          onClick={toggle}
        >
          <DefaultButtonContent formattedDateObj={formattedDateObj} value={value} renderFn={children}>
            <Text weight='bold'>{formattedDateObj.date}</Text>
          </DefaultButtonContent>
        </Button>
        {formattedDateObj.isValid && (
          <Tooltip {...tooltipProps}>
            {t(`${formattedDateObj.day} ${formattedDateObj.date}, ${formattedDateObj.year}`)}
          </Tooltip>
        )}
        {showError && errorElement}
      </div>
    </>
  );
};
